import React, { useState, useEffect } from "react";
import eventEmitter from "./eventEmitter";
import "./CustomPopup.css"; // Import the CSS file

const CustomPopup = () => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState("info");

  useEffect(() => {
    const handleNotification = ({ message, type, time }) => {
      setMessage(message);
      setType(type);
      setShow(true);

      const timer = setTimeout(
        () => {
          setShow(false);
        },
        time ? time : 5000,
      ); // Close after 3 seconds

      return () => clearTimeout(timer);
    };

    eventEmitter.subscribe("notification", handleNotification);

    return () => {
      eventEmitter.events["notification"] = eventEmitter.events[
        "notification"
      ].filter((listener) => listener !== handleNotification);
    };
  }, []);

  const getAlertClassName = () => {
    switch (type) {
      case 1:
        return "alert alert-success";
      case 2:
        return "alert alert-danger";
      case 3:
        return "alert alert-warning";
      default:
        return "alert alert-info";
    }
  };

  return (
    <>
      {message &&
        <>
          {show && (
            <div
              className={`custom-popup ${getAlertClassName()}`}
              role="alert"
              style={{
                background:
                  type == 1
                    ? "green"
                    : type == 2
                      ? "red"
                      : type == 3
                        ? "yellow"
                        : "blue",
              }}
            >
              {message}
              <button
                type="button"
                className="close"
                onClick={() => setShow(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
          )}
        </>}
    </>

  );
};

export default CustomPopup;
